import { useState } from 'react';
import {
  HOME_DIRECTION_ICON_PATHS,
  type HomeDirectionId,
} from '../config/homeDirectionIcons.ts';

type HomeDirectionIconProps = {
  id: HomeDirectionId;
  tone: 'teal' | 'gold';
};

export function HomeDirectionIcon({ id, tone }: HomeDirectionIconProps) {
  const [missing, setMissing] = useState(false);
  const src = HOME_DIRECTION_ICON_PATHS[id];

  return (
    <div
      className={`home-direction-icon-wrap home-direction-icon-wrap--${tone}${
        missing ? ' home-direction-icon-wrap--empty' : ''
      }`}
    >
      {!missing ? (
        <img
          src={src}
          alt=""
          className="home-direction-icon-img"
          onError={() => setMissing(true)}
        />
      ) : null}
    </div>
  );
}
